<div id="nirf" class="watermark">
  <div class="container-fluid px-lg-5">
    <div class="row">
      <div class="col-12">
        <h2 class="title">NIRF</h2>
        <div class="card">
          <div class="card-body text-center">
            <pdf-viewer
              src="/assets/pdf/iqac/NIRF-2024-report-Shah-Satnam-Ji-Girls-College-Sirsa20231229.pdf"
              [render-text]="true"
              [original-size]="false"
              style="width: 100%; height: 680px; position: relative;"
              class="mb-4">
            </pdf-viewer>
            <a href="/assets/pdf/iqac/NIRF-2024-report-Shah-Satnam-Ji-Girls-College-Sirsa20231229.pdf" download class="download-btn mt-2">
              <i class="fa fa-download"></i> Download NIRF PDF
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
